var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('add-representative-request-applicant',{attrs:{"form-model":_vm.formModel,"is-new-mode":_vm.isNewMode,"is-view-mode":_vm.isViewMode,"is-edit-mode":_vm.isEditMode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }